import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

export type ArrayAttributeOptions = BaseAttributeOptions;

// Attribute for array values.
export class ArrayAttribute extends BaseAttribute {
  constructor(options: ArrayAttributeOptions = {}) {
    super(options);
  }

  getInitialValue(): unknown {
    if (this.creationValue !== undefined && this.creationValue !== null) {
      return this.creationValue;
    }
    return [];
  }
}
